import { render } from "./HostLoginScreen.vue?vue&type=template&id=07cfe5f5&scoped=true"
import script from "./HostLoginScreen.vue?vue&type=script&lang=js"
export * from "./HostLoginScreen.vue?vue&type=script&lang=js"

import "./HostLoginScreen.vue?vue&type=style&index=0&id=07cfe5f5&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-07cfe5f5"

export default script